import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultPaginationSettings,
  defaultRateLimitationSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { JuniperMistApiSettingsDefaults } from './types';

export const juniperMistDefaults: JuniperMistApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultPaginationSettings,
  ...defaultRateLimitationSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 250,
};
